import {createContext, useContext} from "react";


export type WidgetSettingsT = {
    excludeFilterFiled: string[];
    filterParams: { [key: string]: string[] };
    apiChannel: string | null
};

const defaultSettings: WidgetSettingsT = {
    excludeFilterFiled: [],
    filterParams: {},
    apiChannel: null,
};

// Создаём контекст для настроек виджета с явным типом
export const WidgetSettingsContext = createContext<WidgetSettingsT>(defaultSettings);

// Хук для использования контекста в компонентах
export const useWidgetSettings = () => useContext<WidgetSettingsT>(WidgetSettingsContext);
